/* eslint-disable */
import React from 'react';
import compose from 'lodash/fp/compose';
import styled from 'styled-components';
import check from 'check-types';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  withCountry,
  withTitle,
  withEthnicGroup,
  withSex,
  withReligion,
  withHeightUnit,
  withMaritalStatus,
  withEyeColor,
  withPersonalInfo,
  withCustomRouter,
  withTranslation,
  withDependentField,
  withTimeDependentName,
  withUserPreferences,
  withLanguage,
  withMsgInfo,
} from 'components/hoc';
import {
  Select,
  Input,
  Form,
  InputDatePicker,
  ButtonLink,
  FileInput,
  Image,
  NewEntriesSelect,
  Button,
} from 'components/common/FormItems';
import { isEmptyValue } from 'components/utils/checkValue';
import { excludeUnsetField } from 'components/utils/excludeUnsetField';
import axios from '../../../../../axios';
import API from 'actions/api';
import Swal from 'sweetalert2';
import { RESPONSE_STRINGS } from '../../../../../constants/index';
import { getResError } from '../../../../../actions/account';

const Wrapper = styled.div``;

const ImageWrapper = styled.div`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
`;


const StyledButton = styled(Button)`
  width: ${(props) => (props.width ? props.width : '8.0625rem')};
  height: 2.5rem;
  line-height: 1.25rem;
  font-weight: 500;
  font-size: 1rem;
  marginLeft: 1.25rem;
  border: ${(props) => (props.border ? props.border : 'none')};
  border-radius: 7px;
  color: ${(props) => (props.color ? props.color : '#fff')};
  background: ${(props) => (props.background ? props.background : '#4C81BE')};
  transition: all ease-in-out 300ms;
  ${({ border }) =>
    border &&
    css`
      border: solid 1px #1d579b;
      border-radius: 7px;
    `}

  &:hover {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.29);
  }
`;

const DualInputWrapper = styled.div`
  display: flex;
  // justify-content: space-between;
  flex-wrap: wrap;
  margin-left: 1rem;
 
  > div {
    min-width: 150px;
    flex: 1;
    margin-right: 1rem;

    :last-child {
      margin-left: 1rem;
       margin-right: 1rem;
    }
  }
`;

const DualSelectWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-left: 1rem;
  
  > div {
    min-width: 150px;
    flex: 1;
    margin-right: 1rem;

    :last-child {
    margin-left: 1rem;
    margin-right: 1rem;
    }
  }
`;

const NewEntriesSelectField = styled(NewEntriesSelect)`
  margin-left: 1rem;
  margin-right: 2rem;
`;

const StyledInputDatePicker = styled(InputDatePicker)`
  padding-right: 0.8rem;
`;

const StyledInput = styled(Input)`
  padding-right: 0.7rem;
`;

const StyledSelect = styled(Select)`
  padding-right: 0.5rem;
`;

const StyledFileInput = styled(FileInput)`
  padding-right: 0.9rem;
`;

const StyledButtonLink = styled(ButtonLink)`
  span {
    text-transform: uppercase;
  }
`;

const FormAreaDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media only screen and (max-width: 600px) {
    flex-direction: column;
  }
`;

const FormFlex = styled.div`
  flex: 1;
  // padding:5px;
  position: relative;
  margin: 5px;

  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`;

const personFormSchema = {
  last_name: {
    validation: 'required',
  },
  first_name: {
    validation: 'required',
  },
  date_of_birth: {
    validation: 'required',
  },
};

const PersonalInfoForm = (props) => {
  const {
    addPersonalInfo,
    updatePersonalInfo,
    getPersonalInfoById,
    routeParams,
    addTimeDependentName,
    userPreferences,
    activeLanguageOptions,
    basePath,
    setMsgInfo,
  } = props;

  const navigate = useNavigate();

  const { id: personId } = routeParams;
  const [formData, setFormData] = React.useState({});
  const [initialData, setInitialData] = React.useState({});
  const [formSubmitting, setFormSubmitting] = React.useState(false);
  const [formLoading, setFormLoading] = React.useState(false);
  const [entrySubmitting, setEntrySubmitting] = React.useState(false);
  const [showEntryForm, setShowEntryForm] = React.useState(false);
  const [showReligionEntryForm, setShowReligionEntryForm] = React.useState(false);
  const [entryValues, setEntryValues] = React.useState({
    value: '',
    language: userPreferences.language,
  });

  const dispatch = useDispatch();

  // const fetchData = async () => {
  //   if (personId) {
  //     try {
  //       setFormLoading(true);
  //       const { person_picture, ...rest } = await getPersonalInfoById(personId);
  //       const fullData = { person_picture: person_picture?.url, ...rest };
  //       setInitialData(fullData);
  //       setFormData(fullData);
  //     } finally {
  //       setFormLoading(false);
  //     }
  //   }
  // };


  const fetchData = async () => {
    if (personId) {
      try {
        setFormLoading(true);
        const { person_picture, ...rest } = await getPersonalInfoById(personId);
        const birthCountryValue = rest.birth_country_id || rest.birth_country;
        const fullData = {
          person_picture: person_picture?.url,
          ...rest,
          birth_country: birthCountryValue,
        };
        setInitialData(fullData);
        setFormData(fullData);
      } finally {
        setFormLoading(false);
      }
    }
  };

  const toggleEntryField = () => {
    setShowEntryForm(!showEntryForm);
  };

  const toggleReligionEntryField = () => {
    setShowReligionEntryForm(!showReligionEntryForm);
  };

  React.useEffect(() => {
    fetchData();
    return () => null;
  }, []);

  const onEntryChange = (e) => {
    const { value, name } = e.target;
    setEntryValues({ ...entryValues, [name]: value });
  };

  const validateAndSubmitEntry = async (entryType) => {
    if (!(entryValues.name && entryValues.language)) {
      Swal.fire(
        tr('Warning!'),
        tr(`Please ensure all required fields are populated.`),
        'warning',
      );
      return;
    }
    try {
      setEntrySubmitting(true);
      const payload = {
        name: entryValues.name,
        language: entryValues.language,
        entry_type: entryType,
      };
      await axios.post(`${API}/propose/entry/`, payload);
      Swal.fire(
        tr('Success!'),
        tr(`${RESPONSE_STRINGS?.ENTRY_RESPONSE_SUCCESS_MESSAGE}`),
        'success',
      );
      setEntryValues({});
      setEntrySubmitting(false);
      setShowEntryForm(false);
      setShowReligionEntryForm(false);
      return;
    } catch (error) {
      setEntrySubmitting(false);
      setShowEntryForm(false);
      setShowReligionEntryForm(false);
      const err = getResError(error);
      dispatch(setMsgInfo({ success: false, msg: err }));
    } finally {
      setEntrySubmitting(false);
      setShowEntryForm(false);
      setShowReligionEntryForm(false);
    }
  };




  const onChange = (e) => {
    if (formSubmitting) return;
    const { value, name, files } = e.target;
    // Handle file inputs specifically
    if (name === 'person_picture' && files && files[0]) {
      setFormData({ 
        ...formData, 
        [name]: files[0] 
      });
      return;
    }
    const finalValue = value === '' ? null : value;
    setFormData({ 
      ...formData, 
      [name]: finalValue 
    });
  };
  

  
  const onSubmit = async (e) => {
    if (formSubmitting) return;
    let payload = excludeUnsetField(formData, initialData);
  
    if (!payload.height_unit || !payload.height) {
      let { height, height_unit, ...rest } = payload;
      payload = rest;
    }
    const fData = new FormData();
  
    Object.entries(payload).forEach(([key, value]) => {
      if (key === 'person_picture') {
        // Only append if it's a File object (new upload)
        if (value instanceof File) {
          fData.append(key, value);
        }
        // Skip if it's a string (existing URL) or null/undefined
      } else {
        fData.append(key, value);
      }
    });
  
    try {
      setFormSubmitting(true);
      let result = {};
      if (!formData.id) {
        result = await addPersonalInfo(fData);
        await addTimeDependentName({
          person_id: result.id,
          last_name: payload.last_name,
          valid_from: result.date_of_birth,
          reason: 'birth',
        });
        dispatch(
          setMsgInfo({
            success: true,
            msg: [`${tr('Person added successfully')}`],
          }),
        );
      } else {
        await updatePersonalInfo(formData.id, fData);
        dispatch(
          setMsgInfo({
            success: true,
            msg: [`${tr('Person updated successfully')}`],
          }),
        );
      }
      navigate(basePath);
      window.scrollTo(0, 0);
    } catch (e) {
    } finally {
      setFormSubmitting(false);
    }
  };


  // const onChange = (e) => {
  //   if (formSubmitting) return;
  //   const { value, name, files } = e.target;
  //   const finalValue = value === '' ? null : value;
  
  //   setFormData({ 
  //     ...formData, 
  //     [name]: finalValue 
  //   });
  // };

  // const onSubmit = async (e) => {
  //   if (formSubmitting) return;
  //   let payload = excludeUnsetField(formData, initialData);

  //   if (!payload.height_unit || !payload.height) {
  //     let { height, height_unit, ...rest } = payload;
  //     payload = rest;
  //   }
  //   const fData = new FormData();

  //   Object.entries(payload).forEach(([key, value]) => {
  //     if (key === 'person_picture') {
  //       // exluding person_picture if it's string or null, meaning no
  //       // change made to the field
  //       if (!check.string(value) && !isEmptyValue(value)) {
  //         fData.append(key, value);
  //       }
  //     } else {
  //       // fData.append(key, value === null ? '' : value);
  //       fData.append(key, value);
  //     }
  //   });

  //   try {
  //     setFormSubmitting(true);
  //     let result = {};
  //     if (!formData.id) {
  //       result = await addPersonalInfo(fData);
  //       await addTimeDependentName({
  //         person: result.id,
  //         last_name: payload.last_name,
  //         valid_from: result.date_of_birth,
  //         reason: 'birth',
  //       });
  //       dispatch(
  //         setMsgInfo({
  //           success: true,
  //           msg: [`${tr('Person added successfully')}`],
  //         }),
  //       );
  //     } else {
  //       await updatePersonalInfo(formData.id, fData);
  //       dispatch(
  //         setMsgInfo({
  //           success: true,
  //           msg: [`${tr('Person updated successfully')}`],
  //         }),
  //       );
  //     }
  //     navigate(basePath);
  //     window.scrollTo(0, 0);
  //   } catch (e) {
  //   } finally {
  //     setFormSubmitting(false);
  //   }
  // };


  
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  const formId = formData.id;
  const { tr, gotoPath } = props;
  const gotoTimeDependent = () => gotoPath(`${formId}/time-dependent-name`);
  const lastNameLabel = !formData.id ? 'Last Name at birth' : 'Last Name';
  const updateMode = !isEmptyValue(formId);
  const LastNameInputField = withDependentField(
    <Input
      value={formData.last_name || ''}
      onChange={onChange}
      name="last_name"
      id="last_name"
      placeholder={lastNameLabel}
      label={lastNameLabel}
      disabled={!!formData.id}
      showRequiredAsterisk
    />,
    { toggleButton: updateMode, onClick: gotoTimeDependent },
  );

  // Helper function to capitalize option labels
  const capitalizeOptions = (options) => {
    return options?.map(option => ({
      ...option,
      long_description_eng: option.long_description_eng?.charAt(0).toUpperCase() + option.long_description_eng?.slice(1).toLowerCase(),
      long_description_deu: option.long_description_deu?.charAt(0).toUpperCase() + option.long_description_deu?.slice(1).toLowerCase(),
    })) || [];
  };

  const renderActionButtons = (formProps) => {
    const { tr, isLoading, loadingData, detailMode } = formProps;
    return (
      !detailMode && (
        <div style={{ marginLeft: '1.0rem', display: 'flex' }}>  
          <StyledButton
            isLoading={isLoading}
            type="submit"
            name={tr('Save')}
            disabled={loadingData || detailMode}
          />
        </div>
      )
    );
  };

  return (
    <Wrapper className="form-wrapper">
      <div className="flex">
        <StyledButtonLink
          to={basePath}
          className="option-btn"
          icon="angle double left"
          name="All Entries"
        />
      </div>
      <div className="row">
        <div
          className="col-7 ml-10 mt-30 container"
          style={{
            position: 'relative',
            // paddingLeft: '30px',
            background: 'var(--admincat-color-grey-1)',
          }}
        >
          <br />
          <Form
            onSubmit={onSubmit}
            formData={formData}
            validationSchema={personFormSchema}
            isLoading={formSubmitting}
            loadingData={formLoading}
            title={tr('Persons')}
            renderActionButtons={renderActionButtons} 
            editButtonMarginRight="1.9rem"
            editButtonGap="1rem"
          >
            <FormAreaDiv>
              <FormFlex>
                <ImageWrapper>
                  <Image src={formData.person_picture} />
                </ImageWrapper>
              </FormFlex>
              <FormFlex>
                <StyledFileInput
                  onChange={onChange}
                  // ref={fileRef}
                  value={formData.person_picture}
                  hasError="Error"
                  name="person_picture"
                  label={tr('Person Picture')}
                  accept="image/*"
                />
              </FormFlex>
            </FormAreaDiv>

            <NewEntriesSelectField
              value={formData.title || ''}
              name="title"
              label="Title"
              optionDefaultValue={tr('Choose Title')}
              deselectable
              localeOptions={props.titleLocaleOptions}
              onChange={(e) => {
                if (e.target.value === 'proposeValue') {
                  toggleEntryField();
                  return;
                } else {
                  onChange(e);
                }
              }}
              entryDefaultLanguage={entryValues.language}
              entryValue={entryValues.name}
              entryLanguageValue={entryValues.language}
              entryValueName={'name'}
              entryType={tr('Title')}
              entryLanguageName={'language'}
              onEntryChange={onEntryChange}
              onCreateNewEntry={(e) => {
                e.preventDefault();
                validateAndSubmitEntry('title');
              }}
              add={showEntryForm}
              toggleEntryField={toggleEntryField}
              options={activeLanguageOptions}
              isLoading={entrySubmitting}
              closeEntryForm={() => {
                toggleEntryField();
              }}
            />
            <DualInputWrapper>
              <div>{LastNameInputField}</div>
              <StyledInput
                className="mr-md-1"
                value={formData.first_name || ''}
                onChange={onChange}
                name="first_name"
                id="first_name"
                placeholder="First Name"
                label="First Name"
                showRequiredAsterisk
              />
            </DualInputWrapper>

            <DualInputWrapper>
              <Input
                value={formData.other_names || ''}
                onChange={onChange}
                name="other_names"
                id="other_names"
                placeholder="Other Names"
                label="Other Names"
              />
              <StyledInputDatePicker
                className="mr-md-1"
                label="Birth Date"
                value={formData.date_of_birth || ''}
                name="date_of_birth"
                onChange={onChange}
                showRequiredAsterisk
              />
            </DualInputWrapper>

            <DualInputWrapper>
              <Input
                value={formData.birth_place || ''}
                onChange={onChange}
                name="birth_place"
                id="birth_place"
                placeholder="Birth Place"
                label="Birth Place"
              />
              <StyledSelect
                optionDefaultValue="Choose Birth Country"
                label="Birth Country"
                value={formData.birth_country || ''}
                name="birth_country"
                localeOptions={props.countryLocaleOptions}
                onChange={onChange}
                deselectable
        
              />
            </DualInputWrapper>

            <DualSelectWrapper>
              <Select
                optionDefaultValue="Choose Sex"
                label="Sex"
                value={formData.sex || ""}
                name="sex"
                onChange={onChange}
                // localeOptions={props.sexLocaleOptions}
                localeOptions={capitalizeOptions(props.sexLocaleOptions)}
                deselectable
                sort={false}
              />
              <StyledSelect
                optionDefaultValue="Choose Marital Status"
                label="Marital Status"
                value={formData.marital_status || ''}
                name="marital_status"
                onChange={onChange}
                localeOptions={capitalizeOptions(props.maritalStatusLocaleOptions)}
                // localeOptions={props.maritalStatusLocaleOptions}
                deselectable
                sort={false}
              />
            </DualSelectWrapper>

            <DualSelectWrapper>
              <NewEntriesSelect
                value={formData.religion || ''}
                name="religion"
                label="Religion"
                optionDefaultValue={tr('Choose Religion')}
                deselectable
                localeOptions={props.religionLocaleOptions}
                onChange={(e) => {
                  if (e.target.value === 'proposeValue') {
                    toggleReligionEntryField();
                    return;
                  } else {
                    onChange(e);
                  }
                }}
                entryDefaultLanguage={entryValues.language}
                entryValue={entryValues.name}
                entryLanguageValue={entryValues.language}
                entryValueName={'religion'}
                entryType={tr('Religion')}
                entryLanguageName={'language'}
                onEntryChange={onEntryChange}
                onCreateNewEntry={(e) => {
                  e.preventDefault();
                  validateAndSubmitEntry('religion');
                }}
                add={showReligionEntryForm}
                toggleEntryField={toggleReligionEntryField}
                options={activeLanguageOptions}
                isLoading={entrySubmitting}
                closeEntryForm={() => {
                  toggleReligionEntryField();
                }}
              />
              <StyledSelect
                optionDefaultValue="Choose Eye Color"
                label="Eye Color"
                value={formData.eye_color || ''}
                name="eye_color"
                localeOptions={capitalizeOptions(props.eyeColorLocaleOptions)}
                onChange={onChange}
                deselectable
                sort={false}
              />
            </DualSelectWrapper>

            <DualInputWrapper>
              <Input
                placeholder="Height"
                label="Height"
                value={formData.height || ''}
                name="height"
                fieldType="number"
                onChange={onChange}
              />
              <StyledSelect
                style={{ marginLeft: '0.5rem' }}
                optionDefaultValue="Choose Height Unit"
                label="Height Unit"
                value={formData.height_unit || ''}
                name="height_unit"
                localeOptions={props.heightUnitLocaleOptions}
                onChange={onChange}
                deselectable
                sort={false}
              />
              <StyledInputDatePicker
                className="ml-sm-1 mr-md-1"
                label="Death Date"
                value={formData.date_of_death}
                name="date_of_death"
                onChange={onChange}
              />
            </DualInputWrapper>
          </Form>
        </div>
      </div>
    </Wrapper>
  );
};

export default compose(
  withPersonalInfo,
  withCountry,
  withTitle,
  withEthnicGroup,
  withSex,
  withReligion,
  withHeightUnit,
  withMaritalStatus,
  withEyeColor,
  withCustomRouter,
  withTranslation,
  withLanguage,
  withUserPreferences,
  withTimeDependentName,
  withMsgInfo,
)(PersonalInfoForm);